<template>
  <div class="chart-table-box">
    <div class="chart-title-styl" v-if="chartTitleVisible">{{chartTitle}}</div>
    <div class="chart-cont-table"  v-if="!showPlacehold">
      <el-table
        :data="tableData"
        class="dataTable"
        style="width: 100%">
        <el-table-column
          :prop="item.tableColumnName"
          :label="item.tableColumnDesc"
          v-for="(item,index) in columns"
          :key="index"
          >
        </el-table-column>
      </el-table>
      <dyPaging :paging="paging"></dyPaging>
    </div>
    <img
      src="http://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/01/1642400313058.png" alt=""
      class="placehold-img"
      v-if="showPlacehold"
    >
  </div>
</template>

<script>
export default {
  name: "chartTable",
  props: {
    receiveProps:{
      type: [Object, Array],
      default: ()=>{}
    }
  },
  components:{
    dyPaging: ()=>import('./components/paging')
  },
  data(){
    return {
      showPlacehold: false, //是否显示占位
      chartTitle: '', // 标题
      chartTitleVisible: false, // 标题显隐
      tableData: [],
      columns: [], // 表头
      paging: {
        params: {
          pageNum: 1,
          pageSize: 10,
        },
        total: 0
      }
    }
  },
  mounted() {
    console.log(this.receiveProps,'chart-table')
    this.getDataList()
  },
  methods: {
    async getDataList() {
      let detailedStatement = this.receiveProps.tempData.detailedStatement;
      if (!detailedStatement) {
        this.showPlacehold = true;
        return;
      }
      let {dataContent,dataSet,dataSettings} = detailedStatement;
      //标题设置
      this.chartTitle = dataSettings.chartTitle;
      this.chartTitleVisible = dataSettings.chartTitleVisible;
      // 分页
      let page = this.paging.params;
      let columns = dataContent.metricDto; // 设置表头
      this.columns = columns;
      if (!columns.length) return;
      let columnParam = []
      for (var i = 0; i < columns.length; i++) {
        columnParam.push(columns[i].tableColumnName)
      }
      let param = {
        columns: columnParam,
        dashBoardFilter: {
          enumId: dataContent.dataFilter, //过滤条件 0,日 2,月 3,年 4,累计
          gt0: dataContent.measurement.tableColumnName,// 大于0的字段名
          tableColumnName: 'dim_date_type',// 字段名过滤条件
          top10: dataContent.topTen
        },
        dataSetId: dataSet.id,
        sortData: {
          tableColumnName: dataContent.sortData && dataContent.sortData.tableColumnName ? dataContent.sortData.tableColumnName : '',
          sortDesc: dataContent.chartSort ? dataContent.chartSort : ''
        },
        ...page
      }
      
      try {
       let res = await this.$apipcs.chart.getChartTable(param);
       if (res.success) {
         this.tableData = res.data.list;
         this.paging.total = res.data.total;
       }
      } catch(err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../asset/chart.css";
  .chart-table-box {
    max-width: 1200px;
    margin: 0 auto;
    background: #fff;
    margin-bottom: 16px;
  }
  .chart-cont-table {
    padding: 16px;
    box-sizing: border-box;
  }
  /deep/.dataTable {
    &.el-table {
      .el-table__header thead th {
        background: #F7F8FA ;
        height: 40px;
        padding: 10px 0px 10px 0px;
        box-sizing: border-box;
        .cell {
          color: #333;
          font-weight: 600;
          font-size: 14px;
          box-sizing: border-box;
        }
        &.el-table td {
          padding: 8px 0;
        }
      }
    }
  }
</style>